import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';

const AffiliateForm = ({ formData, errors, onChange }) => {
  const networkTypeOptions = [
    { value: 'recruitment', label: 'Recruitment Bureau' },
    { value: 'trade_org', label: 'Branche Organisatie' },
    { value: 'training', label: 'Opleidingsinstituut' },
    { value: 'business_dev', label: 'Business Development' },
    { value: 'consultant', label: 'Consultant' },
    { value: 'other', label: 'Anders' }
  ];

  const referralCapabilityOptions = [
    { value: 'contractors', label: 'Vakmensen' },
    { value: 'clients', label: 'Opdrachtgevers' },
    { value: 'both', label: 'Beide' },
    { value: 'projects', label: 'Projecten' },
    { value: 'partnerships', label: 'Partnerships' }
  ];

  const commissionStructureOptions = [
    { value: 'percentage', label: 'Percentage per opdracht' },
    { value: 'fixed', label: 'Vast bedrag per verwijzing' },
    { value: 'tiered', label: 'Gestaffelde commissie' },
    { value: 'custom', label: 'Aangepast' }
  ];

  return (
    <div className="space-y-6">
      <div className="space-y-4">
        <h3 className="text-lg font-semibold text-foreground flex items-center gap-2">
          <Icon name="Users" size={20} />
          Netwerk Informatie
        </h3>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            label="Bedrijfsnaam"
            type="text"
            placeholder="Uw bedrijfsnaam"
            value={formData?.companyName || ''}
            onChange={(e) => onChange('companyName', e?.target?.value)}
            error={errors?.companyName}
            required
          />

          <Select
            label="Type Netwerk"
            options={networkTypeOptions}
            value={formData?.networkType}
            onChange={(value) => onChange('networkType', value)}
            placeholder="Selecteer netwerktype"
            error={errors?.networkType}
            required
          />

          <Input
            label="Telefoonnummer"
            type="tel"
            placeholder="+31 6 12345678"
            value={formData?.phone || ''}
            onChange={(e) => onChange('phone', e?.target?.value)}
            error={errors?.phone}
            required
          />

          <Input
            label="Locatie"
            type="text"
            placeholder="Amsterdam, Nederland"
            value={formData?.location || ''}
            onChange={(e) => onChange('location', e?.target?.value)}
            description="Stad of regio"
            error={errors?.location}
          />
        </div>
      </div>

      <div className="border-t border-border pt-6 space-y-4">
        <h3 className="text-lg font-semibold text-foreground flex items-center gap-2">
          <Icon name="TrendingUp" size={20} />
          Verwijzingsmogelijkheden
        </h3>
        
        <Select
          label="Verwijzingsmogelijkheden"
          options={referralCapabilityOptions}
          value={formData?.referralCapabilities || []}
          onChange={(value) => onChange('referralCapabilities', value)}
          multiple
          placeholder="Selecteer wat u kunt verwijzen"
          description="Selecteer alle types verwijzingen die u kunt doen"
          error={errors?.referralCapabilities}
          required
        />

        <Input
          label="Geschat aantal verwijzingen per maand"
          type="number"
          placeholder="10"
          value={formData?.estimatedReferrals || ''}
          onChange={(e) => onChange('estimatedReferrals', e?.target?.value)}
          description="Ongeveer aantal verwijzingen dat u verwacht te doen"
          error={errors?.estimatedReferrals}
        />
      </div>

      <div className="border-t border-border pt-6 space-y-4">
        <h3 className="text-lg font-semibold text-foreground flex items-center gap-2">
          <Icon name="DollarSign" size={20} />
          Commissie Voorkeuren
        </h3>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Select
            label="Commissie Structuur"
            options={commissionStructureOptions}
            value={formData?.preferredCommissionStructure}
            onChange={(value) => onChange('preferredCommissionStructure', value)}
            placeholder="Selecteer commissie structuur"
            error={errors?.preferredCommissionStructure}
            required
          />

          <Input
            label="Gewenst Commissie Percentage (%)"
            type="number"
            placeholder="5.0"
            value={formData?.commissionRate || ''}
            onChange={(e) => onChange('commissionRate', e?.target?.value)}
            description="Standaard is 5%"
            error={errors?.commissionRate}
          />
        </div>

        <div className="bg-muted/50 border border-border rounded-lg p-4">
          <p className="text-sm text-muted-foreground">
            <strong>Let op:</strong> De uiteindelijke commissie structuur wordt in overleg bepaald en kan variëren op basis van het type verwijzing en volume.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AffiliateForm;